import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ILayoutElement } from "./ILayoutElement";
import { LayoutManager } from "../Managers/LayoutManager";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ContainerStyle } from "../Components/Elements/Styles/ContainerStyle";
import { StyleManager } from "../Components/Managers/StyleManager";

@engineComponent(ComponentTypes.DisplayObject)
export class LayoutContainerElement extends ContainerElement implements ILayoutElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private portraitStyle: ContainerStyle;

    private styleNodeList: Array<Element>;

    private portraitStyleNodeList: Array<Element>;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();

        LayoutManager.addLayoutElement(this);
    }

    //******************************************************************************************************************
    //  PUBLIC HANDLERS
    //******************************************************************************************************************

    createByNode(node: Element) {
        super.createByNode(node);

        if (node.hasAttribute(LayoutContainerElementAttributes.PORTRAIT_STYLE)) {
            this.portraitStyle = <ContainerStyle>(
                StyleManager.Styles[node.getAttribute(LayoutContainerElementAttributes.PORTRAIT_STYLE)]
            );
            if (this.portraitStyle != null) {
                this.portraitStyleNodeList = this.getNodesList(this.portraitStyle.node.firstElementChild);
            } else {
                if (DEBUG) {
                    this.log(
                        "ERROR no style with name " +
                            node.getAttribute(LayoutContainerElementAttributes.PORTRAIT_STYLE),
                    );
                }
            }
        }

        if (this.style != null) {
            this.styleNodeList = this.getNodesList(this.style.node.firstElementChild);
        }
    }

    onLayoutChange(isPortrait: boolean): void {
        if (isPortrait) {
            this.updateChildElements(this.portraitStyleNodeList, this.styleNodeList);
        } else {
            this.updateChildElements(this.styleNodeList, this.portraitStyleNodeList);
        }
    }

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    private updateChildElements(styleNodeList: Array<Element>, previousStyleNodeList: Array<Element>): void {
        if (styleNodeList != null && previousStyleNodeList != null) {
            if (styleNodeList.length === previousStyleNodeList.length) {
                for (let i = 0; i < styleNodeList.length; i++) {
                    let elementStyle = styleNodeList[i];
                    let previousElementStyle = previousStyleNodeList[i];

                    if (this.childs[elementStyle.nodeName] != null) {
                        this.childs[elementStyle.nodeName].updateByNode(
                            this.updateDefaultValues(elementStyle, previousElementStyle),
                        );
                    }
                }
            }
        }
    }

    private getNodesList(node: Element, nodeList: Array<Element> = []): Array<Element> {
        if (!node) {
            return nodeList;
        }

        if (node.nextElementSibling) {
            nodeList = this.getNodesList(node.nextElementSibling, nodeList);
        }

        return nodeList.concat(node);
    }

    private updateDefaultValues(node: Element, previousNode: Element): Element {
        if (!node.hasAttribute("X") && previousNode.hasAttribute("X")) {
            node.setAttribute("X", "0");
        }

        if (!node.hasAttribute("Y") && previousNode.hasAttribute("Y")) {
            node.setAttribute("Y", "0");
        }

        if (!node.hasAttribute("PivotX") && previousNode.hasAttribute("PivotX")) {
            node.setAttribute("PivotX", "0");
        }

        if (!node.hasAttribute("PivotY") && previousNode.hasAttribute("PivotY")) {
            node.setAttribute("PivotY", "0");
        }

        if (
            !node.hasAttribute("Scale") &&
            !(node.hasAttribute("ScaleX") || node.hasAttribute("ScaleY")) &&
            previousNode.hasAttribute("Scale")
        ) {
            node.setAttribute("Scale", "1");
        }

        if (!node.hasAttribute("Visible") && previousNode.hasAttribute("Visible")) {
            node.setAttribute("Visible", "true");
        }

        if (!node.hasAttribute("RemoveTweens")) {
            node.setAttribute("RemoveTweens", "false");
        }

        //not inclde CASE attribute due to initial case state
        if (node.hasAttribute("Case")) {
            node.removeAttribute("Case");
        }

        return node;
    }

    clone(): LayoutContainerElement {
        const element: LayoutContainerElement = new LayoutContainerElement();

        element.style = this.style;
        element.portraitStyle = this.portraitStyle;
        element.styleNodeList = this.styleNodeList;
        element.portraitStyleNodeList = this.portraitStyleNodeList;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;
        element.name = this.name;

        element.childs = {};
        element.removeChildren();
        for (let key in this.childs) {
            element.childs[key] = this.childs[key].clone();
            element.addChild(element.childs[key]);
        }

        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        }

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}

const LayoutContainerElementAttributes = {
    PORTRAIT_STYLE: "PortraitStyle",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/LayoutContainerElement.ts
 **/